import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'pipeUpdatedAtMqtt'
})
export class PipeUpdatedAtMqtt implements PipeTransform {
    constructor() { }
    transform(updatedAt) {
        if (updatedAt) {
            return moment(updatedAt).format('DD/MM/YYYY HH:mm');
       
        } else {
            return
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeUpdatedAtMqtt.ts